// @flow

import React, { type Node } from 'react';
import styled from 'styled-components';
import { useIncomingPayment, getCountry } from '@tectonics/prs/incoming-payment';

export function Message(): Node {
  const incomingPayment = useIncomingPayment();
  const country = getCountry(incomingPayment);
  switch (country) {
    case 'br':
      return (
        <Root>
          Seu pagamento não foi aprovado
        </Root>
      );

    case 'ar':
    case 'bo':
    case 'cl':
    case 'co':
    case 'ec':
    case 'mx':
    case 'pe':
    case 'uy':
    case 'py':
    case 'pa':
    case 'sv':
    case 'gt':
    case 'do':
    case 'cr':
      return (
        <Root>
          Su pago no fue aprobado
        </Root>
      );

    case 'za':
    case 'ke':
    case 'ng':
    case 'in':
    case 'tz':
    case 'ug':
    case 'zm':
    case 'eg':
    case 'gh':
    case 'jm':
      return (
        <Root>
          Your payment has not been approved
        </Root>
      );
    default:
      throw new Error(`Retry message: no translation found for country ${country}`);
  }
}

const Root = styled.div`
  background: ${props => props.theme.colors.gray(96)};
  font-family: ${props => props.theme.fontFamily.display};
  font-size: 1.4em;
  font-weight: 200;
  padding: 24px;
  text-align: center;

  @media (min-width: 840px) {
    background: none;
    font-size: 2em;
  }
`;
